import { Fragment, jsx, jsxs } from "react/jsx-runtime";
import { checkDetail } from "@event-chat/core";
import { useMemo } from "react";
import zod from "zod";
import FormInput from "./FormInput.js";
import { FormItemProvider } from "./FormProvider.js";
import { useFormCom, useFormItemEmit } from "./utils.js";
const isNamepath = (value)=>'string' == typeof value || Number.isInteger(value);
const FormList = ({ async, initialValue, item, name, rules, schema: sma, type, callback, children, debug, onChange, ...props })=>{
    const Form = useFormCom();
    const schema = useMemo(()=>sma ?? zod.array(zod.unknown()), [
        sma
    ]);
    const fieldName = useMemo(()=>(Array.isArray(name) ? name.filter(isNamepath) : void 0) ?? (isNamepath(name) ? name : void 0), [
        name
    ]);
    const [inputRef, emit] = useFormItemEmit(item);
    return fieldName ? /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx(Form.List, {
                ...props,
                initialValue: initialValue,
                name: fieldName,
                rules: schema ? (rules ?? []).concat([
                    {
                        validator: (_, value)=>checkDetail(value, {
                                async,
                                schema
                            })
                    }
                ]) : rules,
                children: (fields, options, metas)=>/*#__PURE__*/ jsx(FormItemProvider, {
                        parent: name,
                        emit: emit,
                        children: children(fields, options, metas)
                    })
            }),
            /*#__PURE__*/ jsx(Form.Item, {
                ...props,
                name: fieldName,
                hidden: true,
                children: /*#__PURE__*/ jsx(FormInput, {
                    async: async,
                    name: fieldName,
                    ref: inputRef,
                    schema: schema,
                    type: type,
                    callback: callback,
                    debug: debug,
                    onChange: onChange
                })
            })
        ]
    }) : null;
};
const src_FormList = FormList;
export { src_FormList as default };
